import '../../css/blocks/cta.css';

// Wait for the window to fully load before initializing
window.addEventListener('load', () => {
  const ctaBlocks = document.querySelectorAll('.cta');
  
  if (ctaBlocks.length) {
    // Initialize block-specific functionality here
  }
});
